import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ja from "vuetify/src/locale/ja"

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: "md" || "mdi",
    },
    lang: {
        locales: { ja },
        current: "ja"
    }
});
